// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    padding: 20px 0;
    padding-top: 50px;
}

.reset-password-container {
    width: 100%;
    max-width: 400px;
}

.reset-password-form {
    width: 100%;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    font-family: "Rigidica Text Regular", sans-serif;
}

.reset-password-title {
    text-align: center;
    color: #333;
    margin-bottom: 15px;
    font-family: "Rigidica Text Regular", sans-serif;
}

.reset-password-error {
    color: #ff0000;
    margin-bottom: 10px;
    text-align: center;
    font-size: 14px;
    font-family: "Rigidica Text Light", sans-serif;
}

.reset-password-success {
    color: #4caf50;
    margin-bottom: 10px;
    text-align: center;
    font-size: 14px;
    font-family: "Rigidica Text Light", sans-serif;
}

.reset-password-form-group {
    margin-bottom: 15px;
}

.reset-password-label {
    display: block;
    margin-bottom: 5px;
    color: #555;
    font-family: "Rigidica Text Regular", sans-serif;
}

.reset-password-input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    outline: none;
}

.reset-password-input:focus {
    border-color: #555;
}

.reset-password-password-input-container {
    position: relative;
    display: flex;
    align-items: center;
}

.reset-password-password-input-container .reset-password-input {
    flex-grow: 1;
    padding-right: 70px;
}

.reset-password-password-toggle-btn {
    position: absolute;
    right: 5px;
    padding: 4px 10px;
    background: none;
    border: none;
    color: #333;
    cursor: pointer;
    font-size: 12px;
    font-family: "Rigidica Text Regular", sans-serif;
    transition: color 0.3s ease;
}

.reset-password-password-toggle-btn:hover {
    color: #777;
}

.reset-password-button {
    width: 100%;
    background-color: #333;
    color: #fff;
    padding: 10px;
    border: none;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-top: 10px;
    font-family: "Rigidica Text Regular", sans-serif;
}

.reset-password-button:hover {
    background-color: #555;
}

.reset-password-button:disabled {
    background-color: #999;
    cursor: not-allowed;
}

.reset-password-login-link {
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
    font-family: "Rigidica Text Regular", sans-serif;
}

.reset-password-login-link a {
    color: #333;
    text-decoration: none;
}

.reset-password-login-link a:hover {
    text-decoration: underline;
}

.reset-password-loading {
    text-align: center;
    padding: 20px;
    font-family: "Rigidica Text Regular", sans-serif;
    color: #555;
}

.reset-password-invalid-token {
    text-align: center;
    color: #ff0000;
    margin-bottom: 15px;
    font-family: "Rigidica Text Light", sans-serif;
}

/* CSS Media Queries */

@media (max-width: 599px) {
    .reset-password-page {
        padding-top: 60px;
        padding-bottom: 20px;
    }

    .reset-password-container {
        max-width: 320px;
    }

    .reset-password-form {
        padding: 15px;
    }

    .reset-password-title {
        font-size: 1.5rem;
        margin-bottom: 12px;
    }

    .reset-password-error,
    .reset-password-success {
        font-size: 13px;
    }

    .reset-password-input {
        padding: 7px;
    }

    .reset-password-button {
        padding: 8px;
        font-size: 15px;
    }

    .reset-password-login-link {
        font-size: 13px;
        margin-top: 12px;
    }
}

@media (min-width: 600px) and (max-width: 767px) {
    .reset-password-page {
        padding-top: 40px;
    }

    .reset-password-container {
        max-width: 350px;
    }

    .reset-password-title {
        font-size: 1.6rem;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .reset-password-page {
        padding-top: 60px;
    }

    .reset-password-container {
        max-width: 380px;
    }

    .reset-password-title {
        font-size: 1.7rem;
        margin-bottom: 18px;
    }

    .reset-password-form {
        padding: 22px;
    }

    .reset-password-button {
        padding: 11px;
        font-size: 16px;
    }
}

@media (min-width: 1024px) and (max-width: 1279px) {
    .reset-password-page {
        padding-top: 70px;
    }

    .reset-password-container {
        max-width: 400px;
    }

    .reset-password-title {
        font-size: 1.8rem;
        margin-bottom: 20px;
    }

    .reset-password-form {
        padding: 24px;
    }

    .reset-password-button {
        padding: 12px;
        font-size: 16px;
    }

    .reset-password-form-group {
        margin-bottom: 18px;
    }
}

@media (min-width: 1280px) and (max-width: 1439px) {
    .reset-password-page {
        padding-top: 80px;
    }

    .reset-password-container {
        max-width: 420px;
    }

    .reset-password-title {
        font-size: 1.9rem;
        margin-bottom: 22px;
    }

    .reset-password-form {
        padding: 25px;
    }

    .reset-password-form-group {
        margin-bottom: 20px;
    }

    .reset-password-input {
        padding: 9px;
    }

    .reset-password-button {
        padding: 12px;
        font-size: 17px;
    }
}

@media (min-width: 1440px) and (max-width: 1535px) {
    .reset-password-page {
        padding-top: 90px;
    }

    .reset-password-container {
        max-width: 440px;
    }

    .reset-password-title {
        font-size: 2rem;
        margin-bottom: 24px;
    }

    .reset-password-form {
        padding: 28px;
    }

    .reset-password-form-group {
        margin-bottom: 22px;
    }

    .reset-password-input {
        padding: 10px;
    }

    .reset-password-button {
        padding: 13px;
        font-size: 17px;
    }

    .reset-password-error,
    .reset-password-success {
        font-size: 15px;
    }

    .reset-password-login-link {
        font-size: 15px;
        margin-top: 18px;
    }
}

@media (min-width: 1536px) and (max-width: 1919px) {
    .reset-password-page {
        padding-top: 50px;
    }

    .reset-password-container {
        max-width: 460px;
    }

    .reset-password-title {
        font-size: 2.1rem;
        margin-bottom: 26px;
    }

    .reset-password-form {
        padding: 30px;
    }

    .reset-password-form-group {
        margin-bottom: 24px;
    }

    .reset-password-input {
        padding: 11px;
    }

    .reset-password-button {
        padding: 14px;
        font-size: 18px;
    }

    .reset-password-login-link {
        font-size: 16px;
        margin-top: 20px;
    }
}

@media (min-width: 1920px) and (max-width: 2559px) {
    .reset-password-page {
        padding-top: 60px;
    }

    .reset-password-container {
        max-width: 500px;
    }

    .reset-password-title {
        font-size: 2.3rem;
        margin-bottom: 30px;
    }

    .reset-password-form {
        padding: 35px;
    }

    .reset-password-form-group {
        margin-bottom: 26px;
    }

    .reset-password-label {
        font-size: 16px;
        margin-bottom: 8px;
    }

    .reset-password-input {
        padding: 12px;
        font-size: 16px;
    }

    .reset-password-button {
        padding: 15px;
        font-size: 19px;
    }

    .reset-password-password-toggle-btn {
        font-size: 14px;
        padding: 5px 12px;
    }

    .reset-password-login-link {
        font-size: 17px;
        margin-top: 22px;
    }
}

@media (min-width: 2560px) {
    .reset-password-page {
        padding-top: 150px;
    }

    .reset-password-container {
        max-width: 550px;
    }

    .reset-password-title {
        font-size: 2.5rem;
        margin-bottom: 35px;
    }

    .reset-password-form {
        padding: 40px;
        border-radius: 8px;
    }

    .reset-password-form-group {
        margin-bottom: 30px;
    }

    .reset-password-label {
        font-size: 18px;
        margin-bottom: 10px;
    }

    .reset-password-input {
        padding: 14px;
        font-size: 17px;
        border-radius: 6px;
    }

    .reset-password-button {
        padding: 16px;
        font-size: 20px;
        border-radius: 6px;
        margin-top: 15px;
    }

    .reset-password-password-toggle-btn {
        font-size: 15px;
        padding: 6px 14px;
        right: 8px;
    }

    .reset-password-login-link {
        font-size: 18px;
        margin-top: 25px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/ResetPasswordPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,gDAAgD;IAChD,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gDAAgD;IAChD,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA,sBAAsB;;AAEtB;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".reset-password-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: #ffffff;\n    padding: 20px 0;\n    padding-top: 50px;\n}\n\n.reset-password-container {\n    width: 100%;\n    max-width: 400px;\n}\n\n.reset-password-form {\n    width: 100%;\n    padding: 20px;\n    background-color: #ffffff;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.reset-password-title {\n    text-align: center;\n    color: #333;\n    margin-bottom: 15px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.reset-password-error {\n    color: #ff0000;\n    margin-bottom: 10px;\n    text-align: center;\n    font-size: 14px;\n    font-family: \"Rigidica Text Light\", sans-serif;\n}\n\n.reset-password-success {\n    color: #4caf50;\n    margin-bottom: 10px;\n    text-align: center;\n    font-size: 14px;\n    font-family: \"Rigidica Text Light\", sans-serif;\n}\n\n.reset-password-form-group {\n    margin-bottom: 15px;\n}\n\n.reset-password-label {\n    display: block;\n    margin-bottom: 5px;\n    color: #555;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.reset-password-input {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    outline: none;\n}\n\n.reset-password-input:focus {\n    border-color: #555;\n}\n\n.reset-password-password-input-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.reset-password-password-input-container .reset-password-input {\n    flex-grow: 1;\n    padding-right: 70px;\n}\n\n.reset-password-password-toggle-btn {\n    position: absolute;\n    right: 5px;\n    padding: 4px 10px;\n    background: none;\n    border: none;\n    color: #333;\n    cursor: pointer;\n    font-size: 12px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    transition: color 0.3s ease;\n}\n\n.reset-password-password-toggle-btn:hover {\n    color: #777;\n}\n\n.reset-password-button {\n    width: 100%;\n    background-color: #333;\n    color: #fff;\n    padding: 10px;\n    border: none;\n    font-size: 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin-top: 10px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.reset-password-button:hover {\n    background-color: #555;\n}\n\n.reset-password-button:disabled {\n    background-color: #999;\n    cursor: not-allowed;\n}\n\n.reset-password-login-link {\n    text-align: center;\n    margin-top: 15px;\n    font-size: 14px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.reset-password-login-link a {\n    color: #333;\n    text-decoration: none;\n}\n\n.reset-password-login-link a:hover {\n    text-decoration: underline;\n}\n\n.reset-password-loading {\n    text-align: center;\n    padding: 20px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    color: #555;\n}\n\n.reset-password-invalid-token {\n    text-align: center;\n    color: #ff0000;\n    margin-bottom: 15px;\n    font-family: \"Rigidica Text Light\", sans-serif;\n}\n\n/* CSS Media Queries */\n\n@media (max-width: 599px) {\n    .reset-password-page {\n        padding-top: 60px;\n        padding-bottom: 20px;\n    }\n\n    .reset-password-container {\n        max-width: 320px;\n    }\n\n    .reset-password-form {\n        padding: 15px;\n    }\n\n    .reset-password-title {\n        font-size: 1.5rem;\n        margin-bottom: 12px;\n    }\n\n    .reset-password-error,\n    .reset-password-success {\n        font-size: 13px;\n    }\n\n    .reset-password-input {\n        padding: 7px;\n    }\n\n    .reset-password-button {\n        padding: 8px;\n        font-size: 15px;\n    }\n\n    .reset-password-login-link {\n        font-size: 13px;\n        margin-top: 12px;\n    }\n}\n\n@media (min-width: 600px) and (max-width: 767px) {\n    .reset-password-page {\n        padding-top: 40px;\n    }\n\n    .reset-password-container {\n        max-width: 350px;\n    }\n\n    .reset-password-title {\n        font-size: 1.6rem;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1023px) {\n    .reset-password-page {\n        padding-top: 60px;\n    }\n\n    .reset-password-container {\n        max-width: 380px;\n    }\n\n    .reset-password-title {\n        font-size: 1.7rem;\n        margin-bottom: 18px;\n    }\n\n    .reset-password-form {\n        padding: 22px;\n    }\n\n    .reset-password-button {\n        padding: 11px;\n        font-size: 16px;\n    }\n}\n\n@media (min-width: 1024px) and (max-width: 1279px) {\n    .reset-password-page {\n        padding-top: 70px;\n    }\n\n    .reset-password-container {\n        max-width: 400px;\n    }\n\n    .reset-password-title {\n        font-size: 1.8rem;\n        margin-bottom: 20px;\n    }\n\n    .reset-password-form {\n        padding: 24px;\n    }\n\n    .reset-password-button {\n        padding: 12px;\n        font-size: 16px;\n    }\n\n    .reset-password-form-group {\n        margin-bottom: 18px;\n    }\n}\n\n@media (min-width: 1280px) and (max-width: 1439px) {\n    .reset-password-page {\n        padding-top: 80px;\n    }\n\n    .reset-password-container {\n        max-width: 420px;\n    }\n\n    .reset-password-title {\n        font-size: 1.9rem;\n        margin-bottom: 22px;\n    }\n\n    .reset-password-form {\n        padding: 25px;\n    }\n\n    .reset-password-form-group {\n        margin-bottom: 20px;\n    }\n\n    .reset-password-input {\n        padding: 9px;\n    }\n\n    .reset-password-button {\n        padding: 12px;\n        font-size: 17px;\n    }\n}\n\n@media (min-width: 1440px) and (max-width: 1535px) {\n    .reset-password-page {\n        padding-top: 90px;\n    }\n\n    .reset-password-container {\n        max-width: 440px;\n    }\n\n    .reset-password-title {\n        font-size: 2rem;\n        margin-bottom: 24px;\n    }\n\n    .reset-password-form {\n        padding: 28px;\n    }\n\n    .reset-password-form-group {\n        margin-bottom: 22px;\n    }\n\n    .reset-password-input {\n        padding: 10px;\n    }\n\n    .reset-password-button {\n        padding: 13px;\n        font-size: 17px;\n    }\n\n    .reset-password-error,\n    .reset-password-success {\n        font-size: 15px;\n    }\n\n    .reset-password-login-link {\n        font-size: 15px;\n        margin-top: 18px;\n    }\n}\n\n@media (min-width: 1536px) and (max-width: 1919px) {\n    .reset-password-page {\n        padding-top: 50px;\n    }\n\n    .reset-password-container {\n        max-width: 460px;\n    }\n\n    .reset-password-title {\n        font-size: 2.1rem;\n        margin-bottom: 26px;\n    }\n\n    .reset-password-form {\n        padding: 30px;\n    }\n\n    .reset-password-form-group {\n        margin-bottom: 24px;\n    }\n\n    .reset-password-input {\n        padding: 11px;\n    }\n\n    .reset-password-button {\n        padding: 14px;\n        font-size: 18px;\n    }\n\n    .reset-password-login-link {\n        font-size: 16px;\n        margin-top: 20px;\n    }\n}\n\n@media (min-width: 1920px) and (max-width: 2559px) {\n    .reset-password-page {\n        padding-top: 60px;\n    }\n\n    .reset-password-container {\n        max-width: 500px;\n    }\n\n    .reset-password-title {\n        font-size: 2.3rem;\n        margin-bottom: 30px;\n    }\n\n    .reset-password-form {\n        padding: 35px;\n    }\n\n    .reset-password-form-group {\n        margin-bottom: 26px;\n    }\n\n    .reset-password-label {\n        font-size: 16px;\n        margin-bottom: 8px;\n    }\n\n    .reset-password-input {\n        padding: 12px;\n        font-size: 16px;\n    }\n\n    .reset-password-button {\n        padding: 15px;\n        font-size: 19px;\n    }\n\n    .reset-password-password-toggle-btn {\n        font-size: 14px;\n        padding: 5px 12px;\n    }\n\n    .reset-password-login-link {\n        font-size: 17px;\n        margin-top: 22px;\n    }\n}\n\n@media (min-width: 2560px) {\n    .reset-password-page {\n        padding-top: 150px;\n    }\n\n    .reset-password-container {\n        max-width: 550px;\n    }\n\n    .reset-password-title {\n        font-size: 2.5rem;\n        margin-bottom: 35px;\n    }\n\n    .reset-password-form {\n        padding: 40px;\n        border-radius: 8px;\n    }\n\n    .reset-password-form-group {\n        margin-bottom: 30px;\n    }\n\n    .reset-password-label {\n        font-size: 18px;\n        margin-bottom: 10px;\n    }\n\n    .reset-password-input {\n        padding: 14px;\n        font-size: 17px;\n        border-radius: 6px;\n    }\n\n    .reset-password-button {\n        padding: 16px;\n        font-size: 20px;\n        border-radius: 6px;\n        margin-top: 15px;\n    }\n\n    .reset-password-password-toggle-btn {\n        font-size: 15px;\n        padding: 6px 14px;\n        right: 8px;\n    }\n\n    .reset-password-login-link {\n        font-size: 18px;\n        margin-top: 25px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
